import { Panel } from './Panel';
import { formatNumber } from '@/lib/utils';
import type { Character } from '@/types/database';

interface BattleStatsPanelProps {
  character: Character;
}

interface StatProps {
  abbr: string;
  value: number;
  glyph: string;
}

function Stat({ abbr, value, glyph }: StatProps): JSX.Element {
  return (
    <div className="rounded-md border-2 border-wood-mid/30 bg-parchment-light/60 px-3 py-3 text-center shadow-inner">
      <div className="flex items-center justify-center gap-1.5 mb-1.5">
        <span aria-hidden className="text-candle-dark text-sm">
          {glyph}
        </span>
        <span className="text-[0.7rem] font-display uppercase tracking-[0.2em] text-wood-mid">
          {abbr}
        </span>
      </div>
      <div className="font-mono text-2xl sm:text-3xl text-ink leading-none">
        {formatNumber(value)}
      </div>
    </div>
  );
}

export function BattleStatsPanel({ character }: BattleStatsPanelProps): JSX.Element {
  return (
    <Panel title="Battle Stats">
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
        <Stat abbr="STR" glyph="&#x2694;" value={character.strength} />
        <Stat abbr="DEF" glyph="&#x25C6;" value={character.defense} />
        <Stat abbr="AGI" glyph="&#x2726;" value={character.agility} />
        <Stat abbr="DEX" glyph="&#x25CE;" value={character.dexterity} />
      </div>
    </Panel>
  );
}
